import { render, staticRenderFns } from "./AnimalNumbersSheep.vue?vue&type=template&id=64245b68&"
import script from "./AnimalNumbersSheep.vue?vue&type=script&lang=js&"
export * from "./AnimalNumbersSheep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports